import React from 'react';

import { observer } from 'mobx-react-lite';

import { gameStore } from '../../../store/gameStore';
import { doBetStore } from '../../../store/doBetStore';

import BetItem from '../../betItem';

const MobileSceneViewWithProps = observer(
  ({
    itemId,
    isOpenBetPopup,
    totalBetForNote,
    setIsOpenBetPopup,
    isOpenCashOutPopup,
    setTotalBetForNote,
    setIsOpenCashOutPopup,
  }) => {
    const {
      pigs,
      sendCashOut,
      setBetAmount,
      betAmountPopupId,
      setAutoCashOutOdd,
      setBetAmountPopupId,
      autoCashOutQuickOdds,
      autoCashOutOddPopupId,
      setAutoCashOutOddPopupId,
      setIsNexRoundAutoCashOut,
    } = doBetStore;

    const { isBetsClosed } = gameStore;

    const {
      betId,
      isSave,
      winAmount,
      betAmount,
      freeBetId,
      freeBetMinOdd,
      isDisabled,
      isBetAccepted,
      autoCashOutOdd,
      isNextRoundBet,
      isNextRoundAutoCashOut,
    } = pigs[itemId];

    return (
      <BetItem
        betId={betId}
        isSave={isSave}
        itemId={itemId}
        betAmount={betAmount}
        winAmount={winAmount}
        isDisabled={isDisabled}
        sendCashOut={sendCashOut}
        isBetsClosed={isBetsClosed}
        setBetAmount={setBetAmount}
        freeBetId={freeBetId}
        freeBetMinOdd={freeBetMinOdd}
        isBetAccepted={isBetAccepted}
        isOpenBetPopup={isOpenBetPopup}
        autoCashOutOdd={autoCashOutOdd}
        isNextRoundBet={isNextRoundBet}
        totalBetForNote={totalBetForNote}
        betAmountPopupId={betAmountPopupId}
        setIsOpenBetPopup={setIsOpenBetPopup}
        setAutoCashOutOdd={setAutoCashOutOdd}
        setTotalBetForNote={setTotalBetForNote}
        isOpenCashOutPopup={isOpenCashOutPopup}
        setBetAmountPopupId={setBetAmountPopupId}
        autoCashOutQuickOdds={autoCashOutQuickOdds}
        setIsOpenCashOutPopup={setIsOpenCashOutPopup}
        autoCashOutOddPopupId={autoCashOutOddPopupId}
        isNextRoundAutoCashOut={isNextRoundAutoCashOut}
        setAutoCashOutOddPopupId={setAutoCashOutOddPopupId}
        setIsNexRoundAutoCashOut={setIsNexRoundAutoCashOut}
      />
    );
  }
);

export default MobileSceneViewWithProps;
